const MOBILE_MEDIA = "(max-width: 1000px)";

export class Media {
    public static isMobile(): boolean {
        return window.matchMedia(MOBILE_MEDIA).matches;
    }
}
